import React from 'react'
import Moment from 'moment'
import { extendMoment } from 'moment-range'
import { BaseTableStore } from '../new_base'
import { computed } from 'mobx'
import {
  CItemBatchSetAttrStore,
  CItemBatchAddLimitsStore,
  CItemBatchAddRightsStore
} from './batch'
import * as defaultConst from '../../../constants/default_constants'
import * as linkConst from '../../../constants/link_constants'
const moment = extendMoment(Moment)

class CItemTableStore extends BaseTableStore {
  // append implicit filter and embeds for proper request
  getRequestParams (params) {
    const attr = this.store.router.params.entname === 'contract' ? 'contract_id' : 'film_id'
    params[attr] = this.store.router.params.id
    params.embed = 'rights,limits'
    return new Promise((resolve, _) => resolve(params))
  }

  entityname = 'contractitems'
  @computed get attrs () {
    const entFK = this.store.router.params.entname === linkConst.LINK_CONTRACT ? 'film_id' : 'contract_id'
    const contractType = this.store.router.params.entname === linkConst.LINK_FILM ? ['contract_type'] : []
    return [
      // 'edit',
      'id',
      'title',
      entFK,
      ...(contractType),
      'rights',
      'minimal_guarantee',
      'cost_sum',
      'delivered_date',
      'studio_asset_id',
      'platform_specific_licence_period_flg'
    ]
  }

  headerCreator (attr) {
    const val = this.titles(this.store)[attr]
    return val === undefined ? attr : val
  }

  titles = (store) => ({
    edit: '',
    id: 'ID',
    title: store.__('contract title'),
    contract_id: store.__('contract name'),
    film_id: store.__('film name'),
    minimal_guarantee: store.__('minimum guarantee'),
    cost_sum: store.__('cost sum'),
    contract_type: store.__('contract type'),
    delivered_date: store.__('delivered date'),
    studio_asset_id: store.__('studio asset ID'),
    platform_specific_licence_period_flg: store.__('platform specific license period')
  })

  addClicked () {
    const entname = this.store.router.params.entname
    const eid = this.store.router.params.id
    this.store.goTo('contractitem_detail', { entname, eid, id: '_new' })
  }

  goBack () {
    this.store.goTo('entity_detail', {
      entityname: this.store.router.params.entname === 'film' ? 'films' : 'contracts',
      id: this.store.router.params.id
    })
  }

  requiredOptions = [
    'ExpenseTypes',
    'Languages', // for YT table
    'PricingTiers',
    'RightsTypes',
    'Platforms',
    'ContractItemStatus',
    'ContractTypes',
    'Countries',
    'FlyprivateCategories',
    'ContractItemCategory',
    'ContractPricingTier',
    linkConst.LOAD_OPTIONS.contracts,
    linkConst.LOAD_OPTIONS.films,
    linkConst.LOAD_OPTIONS.flyprivate_pricings,
    linkConst.LOAD_OPTIONS.timeRestrictions
  ]

  noSort = ['expensesum', 'rights', 'edit', 'contract_id', 'film_id']

  defaultSortField = 'contract_type,title'
  defaultSortDir = 'ASC,ASC'

  expenseSum (row) {
    const total = row.limits ? row.limits.reduce((acc, i) => {
      return acc + parseInt(i.limit)
    }, 0) : 0
    return total
  }

  @computed get title () {
    const entity = this.store.router.params.entname
    const id = parseInt(this.store.router.params.id)
    const _getContractName = () => {
      const found = this.store.options.get('contracts').find(i => i.id === id)
      return found ? found.name : ''
    }
    const _getFilmName = () => {
      const found = this.store.options.get('films').find(i => i.id === id)
      return found ? found.title : ''
    }
    const entityTitle = entity === 'film' ? this.store.__(linkConst.LINK_FILMS_TITLE) : this.store.__(linkConst.LINK_CONTRACTS_TITLE)
    const itemName = entity === 'film' ? _getFilmName() : _getContractName()
    return (<span>
      <span className='first-to-uppercase'>{entityTitle}</span>
      {defaultConst.TITLE_DIVIDER}
      <span className='text-primary text-strong'>{itemName}</span>
      {defaultConst.TITLE_DIVIDER}
      {entity === 'film' ? this.store.__(linkConst.LINK_FILM_ITEMS_TITLE) : this.store.__(linkConst.LINK_CONTRACT_ITEMS_TITLE)}
    </span>)
  }

  batchStores = {
    set: CItemBatchSetAttrStore,
    addex: CItemBatchAddLimitsStore,
    addRights: CItemBatchAddRightsStore
  }
}

export default CItemTableStore
